<template>
  <div class="container">
    <div class="row">
      <div class="col m-5 text-left">
        <h1>عدم دسترسی <b-icon icon="hand-thumbs-down"></b-icon></h1>
        <p class="text-secondary">شما مجاز به انجام عملیات فوق نیستید</p>
        <b-button variant="outline-secondary" @click="goBack" size="sm" class="mr-2">بازگشت</b-button>
        <b-button variant="outline-secondary" @click="goToPanelIndex" size="sm" class="mr-2">رفتن به داشبورد</b-button>
        <b-button variant="outline-danger" @click="doLogout" size="sm">خروج از پنل</b-button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Forbidden',
  methods: {
    goBack() {
      this.$router.go(-1)
    },
    goToPanelIndex() {
      this.$router.replace('/')
    },
    doLogout() {
      this.$store.commit('logout')
      this.$router.replace({ name: 'LoginRegister' })
    }
  }
}
</script>
